
const API_BASE_URL = 'https://api.prosperasistemas.com/v1';
const API_CREDENTIALS = 'YTRkOGU2MTgtMzkxNy00MGVjLTg4NGEtNWQ3ODNlZmE0ODFjOg==';

export const apiCall = async (endpoint: string, options: RequestInit = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Authorization': `Basic ${API_CREDENTIALS}`,
        'Accept': 'application/json, text/javascript, */*; q=0.01',
        'Accept-Language': 'pt-BR,pt;q=0.6',
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error ${response.status}: ${response.statusText}${errorText ? ` - ${errorText.substring(0, 200)}` : ''}`);
    }

    const contentType = response.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      const textResponse = await response.text();
      if (textResponse.includes('Exception:') || textResponse.includes('erro')) {
        throw new Error('API retornou erro do servidor. Verifique se o endpoint está correto.');
      }
      throw new Error(`API retornou formato inválido. Esperado JSON, recebido: ${contentType}`);
    }

    return await response.json();
  } catch (error: any) {
    throw error;
  }
};

export const testApiEndpoints = async () => {
  const endpoints = [
    '/ordemservico?paginacao=true&pagina=1&itens=10',
    '/ordens-servico?paginacao=true&pagina=1&itens=10',
    '/ordem-servico?paginacao=true&pagina=1&itens=10'
  ];

  for (const endpoint of endpoints) {
    try {
      const result = await apiCall(endpoint);
      return endpoint;
    } catch {
      // try next
    }
  }

  throw new Error('Nenhum endpoint de ordens de serviço funcionou');
};
